import i18n from 'modules/core/lib/i18n'

export type HelpCenterUrl =
  | 'about-contracts-approval-system'
  | 'about-security-settings'
  | 'about_contracts_hours'
  | 'about_contracts_salary'
  | 'about_financial_workspace'
  | 'about_shift_coverage'
  | 'about_the_hiring_pipeline'
  | 'access_to_bookkeeper'
  | 'additional_compensation_types'
  | 'additional_compensations_in_payroll'
  | 'anonymous_surveys'
  | 'applicant_tracking_system'
  | 'ats_calendar_sync'
  | 'ats_create_offer'
  | 'ats_disc_integration'
  | 'ats_import_job_contracts'
  | 'ats_message_board'
  | 'ats_requisitions'
  | 'ats_integrations_join_how_to'
  | 'ats_data_protection_regulations'
  | 'automatic_breaks'
  | 'budgets_landing'
  | 'careers_page'
  | 'company_deletion'
  | 'company_page_job_openings_iframe'
  | 'compensations_cycle_statuses'
  | 'compensations_payroll_concepts'
  | 'competencies_goals'
  | 'contracts-in-factorial'
  | 'contracts_on_payroll_accounts'
  | 'cost_center_employee_assignment'
  | 'create_reports_economics_and_finances'
  | 'developer'
  | 'document_templates'
  | 'documents_in_bulk'
  | 'esignature'
  | 'esignature_request'
  | 'estimated_hours'
  | 'expenses'
  | 'expenses_v2'
  | 'export_calendar'
  | 'face_recognition'
  | 'factorial_processes'
  | 'geolocation_clock_in'
  | 'how_to_contact_support'
  | 'how_to_customize_payroll_contracts'
  | 'how_to_manage_payroll_results'
  | 'how_to_view_and_export_the_annual_balance_report'
  | 'id_clock_shared_device'
  | 'import_contracts'
  | 'import_employees'
  | 'import_supplements'
  | 'insights'
  | 'manage_contracts_fix'
  | 'manage_contracts_promote'
  | 'manage_contracts_update'
  | 'manager_role'
  | 'manual_breaks'
  | 'mfa'
  | 'overtime_compensation_with_time_off'
  | 'payroll_additional_compensations'
  | 'payroll_bundle'
  | 'payroll_finance'
  | 'payroll_incidences'
  | 'payroll_results_1'
  | 'payroll_supplements'
  | 'payroll_variations'
  | 'performance'
  | 'permissions'
  | 'project_management'
  | 'project_management_flexible_tracking'
  | 'publish_on_indeed'
  | 'qr_code_clock_in'
  | 'recruitment'
  | 'reports_errors'
  | 'root'
  | 'saml_google'
  | 'saml_microsoft'
  | 'saml_okta'
  | 'setup_custom_tables'
  | 'share_job_offer_on_linkedin'
  | 'shift_management_tool'
  | 'shifts'
  | 'space_control'
  | 'subscription_payments'
  | 'survey_reports'
  | 'tasks'
  | 'time_off_available_days'
  | 'time_off_tenure_periods'
  | 'time_planning_tools'
  | 'time_settings_breaks'
  | 'time_tracking'
  | 'time_tracking_employees_clock_in'
  | 'time_tracking_first_steps'
  | 'time_tracking_overnight_shifts_setup'
  | 'time_tracking_tolerance'
  | 'timeoff'
  | 'timeoff_absences'
  | 'timeoff_approvals'
  | 'timeoff_blocked_periods'
  | 'timeoff_counters'
  | 'timeoff_calculations'
  | 'timeoff_policies'
  | 'timeoff_policy_timeline'
  | 'timeoff_reports'
  | 'training'
  | 'training_exports'
  | 'training_insights'
  | 'welcome_space'
  | 'one_ai_permissions'

export type HelpCenterNewRequest = 'new_request'

const getHelpCenterUrl = (type: HelpCenterUrl) => {
  switch (type) {
    case 'about-contracts-approval-system':
      return i18n.t('help_center_urls.about-contracts-approval-system')
    case 'about-security-settings':
      return i18n.t('help_center_urls.about-security-settings')
    case 'about_contracts_hours':
      return i18n.t('help_center_urls.about_contracts_hours')
    case 'about_contracts_salary':
      return i18n.t('help_center_urls.about_contracts_salary')
    case 'about_financial_workspace':
      return i18n.t('help_center_urls.about_financial_workspace')
    case 'about_shift_coverage':
      return i18n.t('help_center_urls.about_shift_coverage')
    case 'about_the_hiring_pipeline':
      return i18n.t('help_center_urls.about_the_hiring_pipeline')
    case 'access_to_bookkeeper':
      return i18n.t('help_center_urls.access_to_bookkeeper')
    case 'additional_compensation_types':
      return i18n.t('help_center_urls.additional_compensation_types')
    case 'additional_compensations_in_payroll':
      return i18n.t('help_center_urls.additional_compensations_in_payroll')
    case 'anonymous_surveys':
      return i18n.t('help_center_urls.anonymous_surveys')
    case 'applicant_tracking_system':
      return i18n.t('help_center_urls.applicant_tracking_system')
    case 'ats_calendar_sync':
      return i18n.t('help_center_urls.ats_calendar_sync')
    case 'ats_create_offer':
      return i18n.t('help_center_urls.ats_create_offer')
    case 'ats_disc_integration':
      return i18n.t('help_center_urls.ats_disc_integration')
    case 'ats_import_job_contracts':
      return i18n.t('help_center_urls.ats_import_job_contracts')
    case 'ats_message_board':
      return i18n.t('help_center_urls.ats_message_board')
    case 'ats_requisitions':
      return i18n.t('help_center_urls.ats_requisitions')
    case 'ats_integrations_join_how_to':
      return i18n.t('help_center_urls.ats_integrations_join_how_to')
    case 'ats_data_protection_regulations':
      return i18n.t('help_center_urls.ats_data_protection_regulations')
    case 'automatic_breaks':
      return i18n.t('help_center_urls.automatic_breaks')
    case 'budgets_landing':
      return i18n.t('help_center_urls.budgets_landing')
    case 'careers_page':
      return i18n.t('help_center_urls.careers_page')
    case 'company_deletion':
      return i18n.t('help_center_urls.company_deletion')
    case 'company_page_job_openings_iframe':
      return i18n.t('help_center_urls.company_page_job_openings_iframe')
    case 'compensations_cycle_statuses':
      return i18n.t('help_center_urls.compensations_cycle_statuses')
    case 'compensations_payroll_concepts':
      return i18n.t('help_center_urls.compensations_payroll_concepts')
    case 'competencies_goals':
      return i18n.t('help_center_urls.competencies_goals')
    case 'contracts-in-factorial':
      return i18n.t('help_center_urls.contracts-in-factorial')
    case 'contracts_on_payroll_accounts':
      return i18n.t('help_center_urls.contracts_on_payroll_accounts')
    case 'cost_center_employee_assignment':
      return i18n.t('help_center_urls.cost_center_employee_assignment')
    case 'create_reports_economics_and_finances':
      return i18n.t('help_center_urls.create_reports_economics_and_finances')
    case 'developer':
      return i18n.t('help_center_urls.developer')
    case 'document_templates':
      return i18n.t('help_center_urls.document_templates')
    case 'documents_in_bulk':
      return i18n.t('help_center_urls.documents_in_bulk')
    case 'esignature':
      return i18n.t('help_center_urls.esignature')
    case 'esignature_request':
      return i18n.t('help_center_urls.esignature_request')
    case 'estimated_hours':
      return i18n.t('help_center_urls.estimated_hours')
    case 'expenses':
      return i18n.t('help_center_urls.expenses')
    case 'expenses_v2':
      return i18n.t('help_center_urls.expenses_v2')
    case 'export_calendar':
      return i18n.t('help_center_urls.export_calendar')
    case 'face_recognition':
      return i18n.t('help_center_urls.face_recognition')
    case 'factorial_processes':
      return i18n.t('help_center_urls.factorial_processes')
    case 'geolocation_clock_in':
      return i18n.t('help_center_urls.geolocation_clock_in')
    case 'how_to_contact_support':
      return i18n.t('help_center_urls.how_to_contact_support')
    case 'how_to_customize_payroll_contracts':
      return i18n.t('help_center_urls.how_to_customize_payroll_contracts')
    case 'how_to_manage_payroll_results':
      return i18n.t('help_center_urls.how_to_manage_payroll_results')
    case 'how_to_view_and_export_the_annual_balance_report':
      return i18n.t('help_center_urls.how_to_view_and_export_the_annual_balance_report')
    case 'id_clock_shared_device':
      return i18n.t('help_center_urls.id_clock_shared_device')
    case 'import_contracts':
      return i18n.t('help_center_urls.import_contracts')
    case 'import_employees':
      return i18n.t('help_center_urls.import_employees')
    case 'import_supplements':
      return i18n.t('help_center_urls.import_supplements')
    case 'insights':
      return i18n.t('help_center_urls.insights')
    case 'manage_contracts_fix':
      return i18n.t('help_center_urls.manage_contracts_fix')
    case 'manage_contracts_promote':
      return i18n.t('help_center_urls.manage_contracts_promote')
    case 'manage_contracts_update':
      return i18n.t('help_center_urls.manage_contracts_update')
    case 'manager_role':
      return i18n.t('help_center_urls.manager_role')
    case 'manual_breaks':
      return i18n.t('help_center_urls.manual_breaks')
    case 'mfa':
      return i18n.t('help_center_urls.mfa')
    case 'overtime_compensation_with_time_off':
      return i18n.t('help_center_urls.overtime_compensation_with_time_off')
    case 'payroll_additional_compensations':
      return i18n.t('help_center_urls.payroll_additional_compensations')
    case 'payroll_bundle':
      return i18n.t('help_center_urls.payroll_bundle')
    case 'payroll_finance':
      return i18n.t('help_center_urls.payroll_finance')
    case 'payroll_incidences':
      return i18n.t('help_center_urls.payroll_incidences')
    case 'payroll_results_1':
      return i18n.t('help_center_urls.payroll_results_1')
    case 'payroll_supplements':
      return i18n.t('help_center_urls.payroll_supplements')
    case 'payroll_variations':
      return i18n.t('help_center_urls.payroll_variations')
    case 'performance':
      return i18n.t('help_center_urls.performance')
    case 'permissions':
      return i18n.t('help_center_urls.permissions')
    case 'project_management':
      return i18n.t('help_center_urls.project_management')
    case 'project_management_flexible_tracking':
      return i18n.t('help_center_urls.project_management_flexible_tracking')
    case 'publish_on_indeed':
      return i18n.t('help_center_urls.publish_on_indeed')
    case 'qr_code_clock_in':
      return i18n.t('help_center_urls.qr_code_clock_in')
    case 'recruitment':
      return i18n.t('help_center_urls.recruitment')
    case 'reports_errors':
      return i18n.t('help_center_urls.reports_errors')
    case 'root':
      return i18n.t('help_center_urls.root')
    case 'saml_google':
      return i18n.t('help_center_urls.saml_google')
    case 'saml_microsoft':
      return i18n.t('help_center_urls.saml_microsoft')
    case 'saml_okta':
      return i18n.t('help_center_urls.saml_okta')
    case 'setup_custom_tables':
      return i18n.t('help_center_urls.setup_custom_tables')
    case 'share_job_offer_on_linkedin':
      return i18n.t('help_center_urls.share_job_offer_on_linkedin')
    case 'shift_management_tool':
      return i18n.t('help_center_urls.shift_management_tool')
    case 'shifts':
      return i18n.t('help_center_urls.shifts')
    case 'space_control':
      return i18n.t('help_center_urls.space_control')
    case 'subscription_payments':
      return i18n.t('help_center_urls.subscription_payments')
    case 'survey_reports':
      return i18n.t('help_center_urls.survey_reports')
    case 'tasks':
      return i18n.t('help_center_urls.tasks')
    case 'time_off_available_days':
      return i18n.t('help_center_urls.time_off_available_days')
    case 'time_off_tenure_periods':
      return i18n.t('help_center_urls.time_off_tenure_periods')
    case 'time_planning_tools':
      return i18n.t('help_center_urls.time_planning_tools')
    case 'time_settings_breaks':
      return i18n.t('help_center_urls.time_settings_breaks')
    case 'time_tracking':
      return i18n.t('help_center_urls.time_tracking')
    case 'time_tracking_employees_clock_in':
      return i18n.t('help_center_urls.time_tracking_employees_clock_in')
    case 'time_tracking_first_steps':
      return i18n.t('help_center_urls.time_tracking_first_steps')
    case 'time_tracking_overnight_shifts_setup':
      return i18n.t('help_center_urls.time_tracking_overnight_shifts_setup')
    case 'time_tracking_tolerance':
      return i18n.t('help_center_urls.time_tracking_tolerance')
    case 'timeoff':
      return i18n.t('help_center_urls.timeoff')
    case 'timeoff_absences':
      return i18n.t('help_center_urls.timeoff_absences')
    case 'timeoff_approvals':
      return i18n.t('help_center_urls.timeoff_approvals')
    case 'timeoff_blocked_periods':
      return i18n.t('help_center_urls.timeoff_blocked_periods')
    case 'timeoff_counters':
      return i18n.t('help_center_urls.timeoff_counters')
    case 'timeoff_calculations':
      return i18n.t('help_center_urls.timeoff_calculations')
    case 'timeoff_policies':
      return i18n.t('help_center_urls.timeoff_policies')
    case 'timeoff_policy_timeline':
      return i18n.t('help_center_urls.timeoff_policy_timeline')
    case 'timeoff_reports':
      return i18n.t('help_center_urls.timeoff_reports')
    case 'training':
      return i18n.t('help_center_urls.training')
    case 'training_insights':
      return i18n.t('help_center_urls.training_insights')
    case 'training_exports':
      return i18n.t('help_center_urls.training_exports')
    case 'welcome_space':
      return i18n.t('help_center_urls.welcome_space')
    case 'one_ai_permissions':
      return i18n.t('help_center_urls.one_ai_permissions')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}

export default function helpCenterUrl(
  name: HelpCenterUrl | HelpCenterNewRequest = 'root',
  params: Record<string, unknown> = {}
): string {
  const path =
    name === 'new_request' ? i18n.t('help_center_urls.new_request', params) : getHelpCenterUrl(name)

  return `https://help.factorialhr.com${path}`
}
